// Author liang gang qiang
// Date 2023-11-13 11:23:40

class SithMomMainProjectPlanDetail {
constructor({
        id = null,
        mainProjectPlanId = '',
        parentId = '',
        wbsLevel = '',
        seq = '',
        type = '',
        activityId = '',
        name = '',
        chineseDescription = '',
        duration = '',
        predecessor = '',
        autoCalculate = '',
        milestoneCode = '',
        resource = '',
        mainBeginTime = '',
        mainEndTime = '',
        mainBaselineBeginTime = '',
        mainBaselineEndTime = '',
        mainBaselineBeginTimeLast = '',
        mainBaselineEndTimeLast = '',
        mainBaselineBeginDeviation = '',
        mainBaselineEndDeviation = '',
        keyInfo = '',
        currentPeriod = '',
        activeStatus = '',
        bufferTime = '',
        missionMode = '',
        lastBeginTime = '',
        lastEndTime = '',
        priority = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mainProjectPlanId = mainProjectPlanId;
    this.parentId = parentId;
    this.wbsLevel = wbsLevel;
    this.seq = seq;
    this.type = type;
    this.activityId = activityId;
    this.name = name;
    this.chineseDescription = chineseDescription;
    this.duration = duration;
    this.predecessor = predecessor;
    this.autoCalculate = autoCalculate;
    this.milestoneCode = milestoneCode;
    this.resource = resource;
    this.mainBeginTime = mainBeginTime;
    this.mainEndTime = mainEndTime;
    this.mainBaselineBeginTime = mainBaselineBeginTime;
    this.mainBaselineEndTime = mainBaselineEndTime;
    this.mainBaselineBeginTimeLast = mainBaselineBeginTimeLast;
    this.mainBaselineEndTimeLast = mainBaselineEndTimeLast;
    this.mainBaselineBeginDeviation = mainBaselineBeginDeviation;
    this.mainBaselineEndDeviation = mainBaselineEndDeviation;
    this.keyInfo = keyInfo;
    this.currentPeriod = currentPeriod;
    this.activeStatus = activeStatus;
    this.bufferTime = bufferTime;
    this.missionMode = missionMode;
    this.lastBeginTime = lastBeginTime;
    this.lastEndTime = lastEndTime;
    this.priority = priority;
    this.remark = remark;
}
}

function newEntity() {
return new SithMomMainProjectPlanDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.id',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainProjectPlanId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainProjectPlanId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'parentId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'level',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbsLevel',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.wbsLevel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'seq',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'type',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.type',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'activityId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.activityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'name',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'chineseDescription',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.chineseDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'duration',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.duration',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'predecessor',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.predecessor',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'autoCalculate',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.autoCalculate',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'milestoneCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.milestoneCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'resource',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.resource',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmForecastStartTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.ppdOmForecastStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ppdOmForecastEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.ppdOmForecastEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'process',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.process',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainBeginTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainBaselineBeginTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainBaselineEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineBeginTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainBaselineBeginTimeLast',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineEndTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainBaselineEndTimeLast',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineBeginDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainBaselineBeginDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineEndDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.mainBaselineEndDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'keyInfo',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.keyInfo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'currentPeriod',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.currentPeriod',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'activeStatus',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.activeStatus',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' }
            ]
                }
        },
        {
        key: 'bufferTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.bufferTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'missionMode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.missionMode',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '自动计划' },
                            { value: '2', text: '手动计划' }
            ]
                }
        },
        {
        key: 'lastBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.lastBeginTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lastEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.lastEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priority',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.priority',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    mainProjectPlanIdFilter : '',
    projectCodeFilter : '',
    mppIdInFilter : [],
    parentIdFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    wbsLevelFilter : '',
    seqFilter : '',
    typeFilter : '',
    activityIdFilter : '',
    nameFilter : '',
    chineseDescriptionFilter : '',
    durationFilter : '',
    predecessorFilter : '',
    autoCalculateFilter : '',
    milestoneCodeFilter : '',
    resourceFilter : '',
    mainBeginTimeRteFilter : '',
    mainBeginTimeLteFilter : '',
    mainEndTimeRteFilter : '',
    mainEndTimeLteFilter : '',
    mainBaselineBeginTimeRteFilter : '',
    mainBaselineBeginTimeLteFilter : '',
    mainBaselineEndTimeRteFilter : '',
    mainBaselineEndTimeLteFilter : '',
    mainBaselineBeginTimeLastRteFilter : '',
    mainBaselineBeginTimeLastLteFilter : '',
    mainBaselineEndTimeLastRteFilter : '',
    mainBaselineEndTimeLastLteFilter : '',
    mainBaselineBeginDeviationFilter : '',
    mainBaselineEndDeviationFilter : '',
    keyInfoFilter : '',
    currentPeriodFilter : '',
    activeStatusFilter : '',
    bufferTimeFilter : '',
    missionModeFilter : '',
    lastBeginTimeRteFilter : '',
    lastBeginTimeLteFilter : '',
    lastEndTimeRteFilter : '',
    lastEndTimeLteFilter : '',
    priorityFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.level',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nodeCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.nodeCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsLevelFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.wbsLevel',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.type',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activityIdFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.activityId',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'chineseDescriptionFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.chineseDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'durationFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.duration',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'predecessorFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.predecessor',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'autoCalculateFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.autoCalculate',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'milestoneCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.milestoneCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'resourceFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.resource',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBeginTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBeginTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainEndTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainEndTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLastRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineBeginTimeLastRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLastLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineBeginTimeLastLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLastRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineEndTimeLastRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLastLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineEndTimeLastLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginDeviationFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineBeginDeviation',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndDeviationFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.mainBaselineEndDeviation',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'keyInfoFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.keyInfo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'currentPeriodFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.currentPeriod',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activeStatusFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.activeStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'bufferTimeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.bufferTime',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'missionModeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.missionMode',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastBeginTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.lastBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastBeginTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.lastBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastEndTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.lastEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastEndTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.lastEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priorityFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.priority',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];
const levelTreeFilterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mainProjectPlanId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainProjectPlanId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'parentId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMomMainProjectPlanDetail'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'wbsLevel',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.wbsLevel',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'type',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activityId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.activityId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'name',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'chineseDescription',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.chineseDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'duration',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.duration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'predecessor',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.predecessor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'autoCalculate',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.autoCalculate',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'milestoneCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.milestoneCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'resource',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.resource',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainBaselineBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainBaselineEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainBaselineBeginTimeLast',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainBaselineEndTimeLast',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainBaselineBeginDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.mainBaselineEndDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'keyInfo',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.keyInfo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'currentPeriod',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.currentPeriod',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activeStatus',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.activeStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'bufferTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.bufferTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'missionMode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.missionMode',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.lastBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.lastEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priority',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.priority',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMomMainProjectPlanDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, levelTreeFilterConfigs


}
